export const style = {
  devider: {
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    border: 0,
    margin: `60px 0`,
    height: `4px`,
    borderTop: `1px solid #ddd`,
    borderBottom: `1px solid #ddd`
  },
  icon: {
    color: `#bbb`,
    fontSize: `20px`,
    lineHeight: `50px`,
    textAlign: `center`,
    background: `white`,
    width: `50px`,
    height: `50px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/devider.js